import api from "../../providers/api";
import history from "../../providers/history";
import { GetObject } from "../../providers/storage";
import { IAuthenticatedUser } from "../authentication/types";
import { IItemNameFilter, IItemNameSaveRequestPayload } from "./types";

export const itemsNamesListRequestService = (filter?: IItemNameFilter) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');
    
    let stringFilter = new URLSearchParams({
        name: filter?.name || '',
        page: String(filter?.page || 1),
        perPage: String(filter?.perPage || 10)
    }).toString();

    return api.get(`settings/text-models/item-name/?${stringFilter}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const itemsNamesSaveRequestService = (itemName: IItemNameSaveRequestPayload, id?:string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    if (id) {
        return api.put(`settings/text-models/item-name/${id}`, itemName, {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
    }

    return api.post('settings/text-models/item-name', itemName, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const itemsNamesRemoveRequestService = ( itemNameId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');
    
    return api.delete(`settings/text-models/item-name/${itemNameId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}